function Remove() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="28" fill="none" viewBox="0 0 24 28">
      <circle cx="12" cy="15" r="11.5" stroke="#D2D0D5" transform="rotate(-180 12 15)"></circle>
      <path fill="var(--black-600)" d="M7.501 16.473h9.351v-1.81H7.501v1.81z" opacity="0.5"></path>
    </svg>
  )
}

export default Remove
